// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const miltank: PokeData = {
  "id": 241,
  "name": "miltank",
  "height": 12,
  "weight": 755,
  "base_experience": 172,
  "types": [
    PokeType.NORMAL
  ],
  "api_moves": [
    "stomp",
    "headbutt",
    "tackle",
    "body-slam",
    "growl",
    "defense-curl",
    "bide",
    "charm",
    "rollout",
    "milk-drink",
    "heal-bell",
    "wake-up-slap",
    "gyro-ball",
    "zen-headbutt",
    "captivate",
    "play-rough",
    "high-horsepower"
  ],
  "moves": [
    "headbutt",
    "tackle",
    "body-slam",
    "growl",
    "heal-bell",
    "zen-headbutt",
    "play-rough",
    "scratch",
    "splash",
    "supersonic",
    "protect",
    "quick-attack",
    "tri-attack"
  ],
  "evolution_chain": {
    "id": 122,
    "item": null,
    "species": [
      {
        "name": "miltank",
        "order": 267,
        "types": [
          PokeType.NORMAL
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      }
    ]
  },
  "stats": {
    "resistance": 135,
    "speed": 147,
    "ability_power": 118
  },
  "stat_changes": [],
  "catch_rate": 45,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
